import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolders24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFolders24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11.102 2a2 2 0 0 1 1.495.67L14.667 5H19a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a2 2 0 0 1 2-2h1V4a2 2 0 0 1 2-2zM3.5 19A1.5 1.5 0 0 0 5 20.5h11a1.5 1.5 0 0 0 1.5-1.5v-7a1.5 1.5 0 0 0-1.5-1.5H3.5zM9.423 6.5a2 2 0 0 1 .174.17L11.667 9H16a3 3 0 0 1 3 3v4.5a1.5 1.5 0 0 0 1.5-1.5V8A1.5 1.5 0 0 0 19 6.5zM4 7.5a.5.5 0 0 0-.5.5v1h6.16L8.476 7.668a.5.5 0 0 0-.374-.168zm3-4a.5.5 0 0 0-.5.5v1h6.16l-1.184-1.332a.5.5 0 0 0-.374-.168z"
            />
        </svg>
    );
}
export default memo(IconFolders24);
